"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EDITORIAL_INFO = void 0;
const EDITORIAL_INFO = exports.EDITORIAL_INFO = 'editorial-info';
